<template>
    <div>
        <!-- 右上角悬浮小程序码图片（放在最外层避免被容器overflow隐藏） -->
        <img v-if="showBaoming" src="@/assets/baoming.png" class="floating-baoming" />
        <div>
            <div class="qiu-container">
                <h1>{{ selectedPrize ? selectedPrize.awardname : '请选择奖项' }}</h1>

                <div class="threejs-photo-wall">
                    <canvas ref="photoWallCanvas"></canvas>
                </div>

                <!-- <div class="result-panel" v-if="winners.length > 0">
                    <h3>中奖名单</h3>
                    <div class="winners-list">
                        <div v-for="(winner, index) in winners" :key="index" class="winner-item">
                            <span class="winner-name">{{ winner.name }}</span>
                            <span class="winner-prize">{{ winner.prize }}</span>
                        </div>
                    </div>
                </div> -->
            </div>

            <div class="bigboxs">

                <div class="control-panel">
                    <!-- 背景音乐控制按钮 -->
                    <button @click="toggleBgm" class="bgm-control">
                        {{ isBgmPlaying ? '🔊 关闭音乐' : '🎵 播放音乐' }}
                    </button>

                    <div class="prize-selector">
                        <label>选择奖项：</label>
                        <select v-model="selectedPrize" @change="onPrizeChange">
                            <option v-for="prize in jiangxiang" :key="prize.id" :value="prize">
                                {{ prize.awardname }}({{
                                    prize.prizenum }})
                            </option>
                        </select>
                    </div>



                    <div class="lottery-info">
                        <span>每次抽取:</span>
                        <input type="number" min="1" class="draw-count-input" v-model.number="drawCountInput" />
                        <span>人</span>
                        <span>已抽次数: {{ getDrawnTimes(selectedPrize) }}</span>
                    </div>

                    <button class="start-btn" @click="toggleLottery" :disabled="isStopping">
                        {{ isDrawing ? '停止抽奖' : '开始抽奖' }}
                    </button>

                    <button class="toggle-baoming-btn" @click="showBaoming = !showBaoming">
                        {{ showBaoming ? '隐藏小程序码' : '显示小程序码' }}
                    </button>

                </div>
            </div>

            <!-- 中奖弹窗 -->
            <div v-if="showWinnerModal" class="winner-modal-overlay" @click="closeWinnerModal">
                <!-- 喜庆氛围图层：参考 drawanli 的 ResultPopup 用法 -->
                <img class="gif-layer gif-caise" :src="caiseGif" />
                <img class="gif-layer gif-fig gif-fig-left" :src="figGif" />
                <img class="gif-layer gif-fig gif-fig-right" :src="figGif" />
                <img class="gif-layer gif-xingxing gif-xingxing-left" :src="xingxingGif" />
                <img class="gif-layer gif-xingxing gif-xingxing-right" :src="xingxingGif" />
              <!--    <img v-if="showJingse" class="gif-layer gif-jingse" :src="jingseGif" /> -->
                <div class="spotlight spotlight-left"></div>
                <div class="spotlight spotlight-right"></div>
                <div class="winner-modal" @click="closeWinnerModal">

                    <div class="modal-content">
                        <div class="prize-section">
                            <div class="prize-image">
                                <img :src="currentPrizeImage" :alt="currentPrizeName" v-if="currentPrizeImage">
                            </div>
                            <div class="prize-name">{{ currentPrizeName }}</div>

                        </div>
                        <div class="winners-section">

                            <div class="winners-list-modal">
                                <div v-for="(winner, index) in currentWinners" :key="index" class="winner-item-modal">
                                    <div class="avatar-wrap">
                                        <img v-if="winner.avatar" :src="winner.avatar" :alt="winner.name"
                                            class="winner-avatar-modal">
                                        <div v-else class="winner-avatar-placeholder">{{winner.name }}
                                        </div>
                                    </div>
                                    <span v-if="winner.name" class="winner-name-modal">{{ winner.phone }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 微信浏览器遮罩层 -->
        <div v-if="isWechatBrowser" class="wechat-mask">
            <div class="wechat-mask-content">
                <h2>程序出错</h2>
                <p>请联系客服</p>
            </div>
        </div>
    </div>
</template>

<script>

import * as THREE from 'three';
import request from '@/utils/request';
import caiseGif from '@/assets/caise.gif';
import figGif from '@/assets/fig.gif';
import jingseGif from '@/assets/jingse.gif';
import xingxingGif from '@/assets/xingxing.gif';
import baomingImg from '@/assets/baoming.png';

export default {
    name: 'Qiu',
    data() {
        return {
            // 背景音乐
            bgm: null,
            isBgmPlaying: false,
            showBaoming: true, // 是否显示右上角小程序码图片

            // 参与人员列表
            participants: [],

            // 新的奖项设置
            jiangxiang: [
                {
                    "id": 1,
                    "awardname": "幸运奖",
                    "prizename": "幸运奖",
                    "prizenum": 10,
                    "onceout": 10,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/taodao.png"
                },
                {
                    "id": 2,
                    "awardname": "三等奖",
                    "prizename": "九阳电饭煲",
                    "prizenum": 3,
                    "onceout": 3,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/dianfanguo.png"
                },
                {
                    "id": 3,
                    "awardname": "二等奖",
                    "prizename": "摩飞锅",
                    "prizenum": 2,
                    "onceout": 2,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/mofei.png"
                },
                {
                    "id": 4,
                    "awardname": "一等奖",
                    "prizename": "戴森吹风机",
                    "prizenum": 2,
                    "onceout": 2,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/chuifengji.png"
                }
            ],

            selectedPrize: null,
            isDrawing: false,
            // 减速停止过程中，禁止重复点击按钮
            isStopping: false,
            currentDrawCount: 0,
            // 每次抽取人数（自己填写，默认当前奖项人数）
            drawCountInput: 0,
            // 各奖项已抽次数计数
            drawnTimesMap: {},
            winners: [],
            drawnRecords: {},
            scene: null,
            camera: null,
            renderer: null,

            // 弹窗相关
            showWinnerModal: false,
            currentPrizeImage: '',
            currentPrizeName: '',
            currentWinners: [],
            // 弹窗氛围 gif 素材
            caiseGif,
            figGif,
            jingseGif,
            xingxingGif,
            showJingse: false,
            jingseTimer: null,
            photoGroup: null,
            animationId: null,
            names: [],
            rotationSpeed: 0.001,
            isWechatBrowser: false,
            autoRefreshTimer: null, // 自动刷新定时器
            renderedCount: 0, // 3D球当前已渲染的真实人数
            renderedNameList: [], // 3D球上已有的人员名单（用于去重）
            BALL_SLOT_COUNT: 150, // 3D球固定位置数
        };
    },
    computed: {
        // 3D球展示用名单（剔除已中奖的），仅用于展示与抽取人数上限参考，不作为按钮禁用条件
        availableParticipants() {
            const allDrawnNames = this.getAllDrawnNames();
            return this.participants.filter(person => !allDrawnNames.includes(person.name));
        }
    },
    watch: {
        // 弹窗打开 1.5 秒后再弹出金色氛围层，与 drawanli 保持一致
        showWinnerModal(visible) {
            if (this.jingseTimer) {
                clearTimeout(this.jingseTimer);
                this.jingseTimer = null;
            }
            this.showJingse = false;
            if (visible) {
                this.jingseTimer = setTimeout(() => {
                    this.showJingse = true;
                }, 1500);
            }
        }
    },
    beforeDestroy() {
        if (this.jingseTimer) {
            clearTimeout(this.jingseTimer);
            this.jingseTimer = null;
        }
        this.stopAutoRefresh();
    },
    async mounted() {


        // 检测是否为微信浏览器
        const ua = navigator.userAgent.toLowerCase();
        this.isWechatBrowser = /micromessenger/.test(ua);
        await this.fetchPrizes();
        // 初始化背景音乐
        this.initBgm();
        // 请求参与人员列表
        await this.fetchParticipants();
        // 启动自动刷新（每10秒静默更新3D球数据）
        this.startAutoRefresh();
        // this.showMockWinnerModalIfNeeded();
    },
    methods: {
        // 中奖弹窗预览：临时直接弹出，确认效果后删除这个方法和 mounted 里的调用即可
        showMockWinnerModalIfNeeded() {
            this.currentPrizeName = '二等奖';
            this.currentPrizeImage = 'https://yiyufenfen.oss-cn-beijing.aliyuncs.com/red-lottery/KSXU4612NQWK/ec985ef2-1110-436a-9f3c-dd14ba4959d7.png';
            this.currentWinners = [
                {
                    name: '张*',
                    avatar: 'https://yiyufenfen.oss-cn-beijing.aliyuncs.com/red-lottery/06d7c59b-a9e0-4268-a2c4-baacabd7513f.jpeg'
                },
                { name: '李*明', avatar: '' },
                { name: '王*', avatar: '' },
                { name: '赵*华', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' },
                { name: '李*明', avatar: '' },
                { name: '王*', avatar: '' },
                { name: '赵*华', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' },
                { name: '李*明', avatar: '' },
                { name: '王*', avatar: '' },
                { name: '赵*华', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' }
            ];
            this.showWinnerModal = true;
        },

        // 初始化背景音乐
        initBgm() {
            try {
                this.bgm = new Audio(require('/static/bgm.mp3'));
                this.bgm.loop = true;
                this.bgm.volume = 0.3;
            } catch (error) {
                console.error('背景音乐加载失败:', error);
            }
        },
        // 切换背景音乐播放状态
        toggleBgm() {
            if (!this.bgm) return;

            if (this.isBgmPlaying) {
                this.bgm.pause();
            } else {
                this.bgm.play().catch(error => {
                    console.error('背景音乐播放失败:', error);
                });
            }
            this.isBgmPlaying = !this.isBgmPlaying;
        },
        // 获取大屏奖项列表
        async fetchPrizes() {
            try {
                const code = this.getActivityCode();
                const response = await request.get('/api/prize/listByCode', {
                    params: { code }
                });

                if (response.data.code === 200 && Array.isArray(response.data.data)) {
                    this.jiangxiang = response.data.data.map(prize => ({
                        ...prize,
                        awardname: prize.name,
                        prizename: prize.name,
                        prizenum: Number(prize.drawPersonCount || 0),
                        onceout: Number(prize.drawPersonCount || 0),
                        prizeimage: this.cleanImageUrl(prize.image)
                    })).filter(prize => prize.prizenum > 0);
                    this.selectedPrize = this.jiangxiang[0] || null;
                    this.drawCountInput = this.selectedPrize ? this.selectedPrize.onceout : 0;
                }
            } catch (error) {
                console.error('获取奖项列表失败:', error);
                alert('获取奖项列表失败，请稍后重试');
            }
        },

        // 获取参与人员列表
        async fetchParticipants() {
            try {
                const code = this.getActivityCode();
                const count = 200;
                const response = await request.get('/api/user/randomUsers', {
                    params: {
                        code,
                        count
                    }
                });

                if (response.data.code === 200) {
                    this.participants = response.data.data.map(this.normalizeParticipant);
                    this.names = this.participants;
                    this.initThreeJSPhotoWall();
                }
            } catch (error) {
                console.error('获取参与人员失败:', error);
                alert('获取参与人员失败，请稍后重试');
            }
        },

        getActivityCode() {
            if (this.$route && this.$route.query && this.$route.query.code) {
                return this.$route.query.code;
            }
            return new URLSearchParams(window.location.search).get('code') || '';
        },

        normalizeParticipant(person) {
            const name = person.username || person.name || '';
            return {
                ...person,
                name,
                maskedName: this.maskName(name),
                avatar: this.cleanAvatarUrl(person.wxAvatar || person.avatar || '')
            };
        },

        maskName(name) {
            if (!name) return '';
            if (name.length === 1) return name;
            if (name.length === 2) return `${name[0]}*`;
            return `${name[0]}${'*'.repeat(name.length - 2)}${name[name.length - 1]}`;
        },

        cleanAvatarUrl(url) {
            return (url || '').replace(/`/g, '').trim();
        },

        cleanImageUrl(url) {
            return (url || '').replace(/`/g, '').trim();
        },

        getWinnerInitial(name) {
            return name ? String(name).charAt(0) : '中';
        },

        getRemainingCount(prize) {
            if (!prize) return 0;
            const drawn = this.getDrawnCount(prize);
            return Math.max(0, prize.prizenum - drawn);
        },

        getDrawnCount(prize) {
            if (!prize) return 0;
            return this.drawnRecords[prize.id] ? this.drawnRecords[prize.id].length : 0;
        },

        getDrawnTimes(prize) {
            if (!prize) return 0;
            return this.drawnTimesMap[prize.id] || 0;
        },

        getAllDrawnNames() {
            const allDrawn = [];
            Object.values(this.drawnRecords).forEach(records => {
                records.forEach(record => {
                    allDrawn.push(record.name);
                });
            });
            return [...new Set(allDrawn)];
        },

        getPrizeOptionText(prize) {
            return `${prize.awardname} (剩余: ${this.getRemainingCount(prize)}/${prize.prizenum})`;
        },

        onPrizeChange() {
            // 切换奖项时每次抽取人数重置为该奖项配置的人数
            this.drawCountInput = this.selectedPrize ? this.selectedPrize.onceout : 0;
        },

        async toggleLottery() {
            // 减速过程中禁止重复操作
            if (this.isStopping) return;

            if (this.isDrawing) {
                // 停止抽奖
                this.stopLottery();
            } else {
                // 开始抽奖
                await this.startLottery();
            }
        },

        async startLottery() {
            if (!this.selectedPrize) {
                alert('请先选择奖项！');
                return;
            }
            // 同一奖项支持多轮抽取：每轮人数用填写值，默认该奖项配置人数；能否继续抽由后端判断
            const want = this.drawCountInput > 0 ? this.drawCountInput : this.selectedPrize.onceout;
            if (want <= 0) {
                alert('请填写每次抽取人数！');
                return;
            }

            // 开始抽奖后停止自动刷新3D球数据
            this.stopAutoRefresh();

            this.isDrawing = true;
            this.currentDrawCount = want;
            // 快速旋转
            this.rotationSpeed = 0.15;
        },

        stopLottery() {
            // 由快到慢减速停止，减速期间锁定按钮
            this.isStopping = true;
            this.decelerateAndStop();
        },

        decelerateAndStop() {
            const decelerate = () => {
                if (this.rotationSpeed > 0.001) {
                    this.rotationSpeed *= 0.95; // 逐渐减速
                    requestAnimationFrame(decelerate);
                } else {
                    this.rotationSpeed = 0.001;
                    this.selectWinners(this.currentDrawCount);
                }
            };
            decelerate();
        },

        async selectWinners(drawCount) {
            try {
                // 调用大屏按奖品抽奖接口，抽取人数由后端按 drawPersonCount 决定
                const response = await request.post('/api/lottery/drawByPrize', {
                    code: this.getActivityCode(),
                    prizeId: this.selectedPrize.id,
                    count: this.currentDrawCount
                });

                if (response.data.code === 200) {
                    const result = response.data.data || {};
                    const selectedWinners = (result.winResults || []).map(this.normalizeParticipant);

                    // 后端从未中奖人员里抽，返回空说明所有人都中过了
                    if (selectedWinners.length === 0) {
                        this.isDrawing = false;
                        alert('没有未中奖的人员了！');
                        return;
                    }

                    // 使用Vue.set确保响应式更新
                    if (!this.drawnRecords[this.selectedPrize.id]) {
                        this.$set(this.drawnRecords, this.selectedPrize.id, []);
                    }

                    selectedWinners.forEach(winner => {
                        this.drawnRecords[this.selectedPrize.id].push({
                            name: winner.name,
                            prize: this.selectedPrize.prizename,
                            time: new Date().toLocaleString()
                        });
                        this.winners.push({
                            name: winner.name,
                            prize: this.selectedPrize.prizename
                        });
                    });

                    // 强制更新drawnRecords以触发计算属性重新计算
                    this.drawnRecords = { ...this.drawnRecords };
                    // 记录该奖项已抽次数+1
                    this.$set(this.drawnTimesMap, this.selectedPrize.id, (this.drawnTimesMap[this.selectedPrize.id] || 0) + 1);

                    this.isDrawing = false;
                    // 3D球纯展示，抽奖不剔除人员，保持初始名单不动

                    // 显示中奖弹窗
                    this.currentPrizeName = this.selectedPrize.prizename;
                    this.currentPrizeImage = this.selectedPrize.prizeimage;
                    this.currentWinners = selectedWinners.map(person => ({
                        name: person.name,
                        phone: person.phone,
                        avatar: person.avatar
                    }));
                    this.showWinnerModal = true;
                } else {
                    this.isDrawing = false;
                    alert('抽奖失败：' + response.data.msg);
                }
            } catch (error) {
                console.error('抽奖失败:', error);
                this.isDrawing = false;
                alert('抽奖失败，请稍后重试');
            } finally {
                // 无论成功失败，减速流程结束，恢复按钮可点击
                this.isStopping = false;
            }
        },

        resetLottery() {
            if (confirm('确定要重置所有抽奖记录吗？')) {
                this.drawnRecords = {};
                this.winners = [];
                this.names = this.participants;
                this.createPhotoWall();
            }
        },

        closeWinnerModal() {
            this.showWinnerModal = false;
            if (this.jingseTimer) {
                clearTimeout(this.jingseTimer);
                this.jingseTimer = null;
            }
            this.showJingse = false;
            this.currentPrizeImage = '';
            this.currentPrizeName = '';
            this.currentWinners = [];
        },

        async initThreeJSPhotoWall() {
            const canvas = this.$refs.photoWallCanvas;
            const container = canvas.parentElement;

            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;

            this.scene = new THREE.Scene();
            this.scene.background = null;

            const aspect = canvas.width / canvas.height;
            this.camera = new THREE.PerspectiveCamera(75, aspect, 0.1, 1000);
            this.camera.position.set(0, 0, 50);
            this.camera.lookAt(0, 0, 0);

            this.renderer = new THREE.WebGLRenderer({
                canvas,
                antialias: true,
                alpha: true
            });
            this.renderer.setSize(canvas.width, canvas.height);
            this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));

            this.photoGroup = new THREE.Group();
            this.scene.add(this.photoGroup);

            await this.createPhotoWall();

            this.animate();

            window.addEventListener('resize', this.onWindowResize);
        },

        async createPhotoWall() {
            if (this.photoGroup.children.length > 0) {
                while (this.photoGroup.children.length > 0) {
                    const child = this.photoGroup.children[0];
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach(m => m.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                    this.photoGroup.remove(child);
                }
            }

            const totalSlots = this.BALL_SLOT_COUNT;
            const realCount = Math.min(this.names.length, totalSlots);
            const goldenRatio = (1 + Math.sqrt(5)) / 2;
            const radius = 23;

            // 随机分配真人到150个位置中，而不是挤在一起
            // slotAssignment[i] = -1 表示空位，>= 0 表示 this.names 中的索引
            const slotAssignment = new Array(totalSlots).fill(-1);
            const availablePositions = Array.from({ length: totalSlots }, (_, i) => i);
            // Fisher-Yates 洗牌，取前 realCount 个位置
            for (let i = availablePositions.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [availablePositions[i], availablePositions[j]] = [availablePositions[j], availablePositions[i]];
            }
            for (let p = 0; p < realCount; p++) {
                slotAssignment[availablePositions[p]] = p;
            }

            const geometry = new THREE.PlaneGeometry(3.2, 3.2);

            for (let i = 0; i < totalSlots; i++) {
                const theta = 2 * Math.PI * i / goldenRatio;
                const phi = Math.acos(1 - 2 * (i + 0.5) / totalSlots);

                const x = radius * Math.sin(phi) * Math.cos(theta);
                const y = radius * Math.sin(phi) * Math.sin(theta);
                const z = radius * Math.cos(phi);

                const personIndex = slotAssignment[i];
                const isEmpty = (personIndex === -1);

                let texture;
                if (!isEmpty) {
                    texture = await this.createAvatarTexture(this.names[personIndex]);
                } else {
                    texture = this.createEmptyAvatarTexture();
                }

                // 真实头像用alphaTest避免透明混合导致颜色变淡，空位用transparent保持透明背景
                const material = new THREE.MeshBasicMaterial({
                    map: texture,
                    side: THREE.DoubleSide,
                    transparent: isEmpty,
                    alphaTest: isEmpty ? 0 : 0.5
                });

                const mesh = new THREE.Mesh(geometry, material);
                mesh.position.set(x, y, z);
                mesh.lookAt(this.camera.position);
                mesh.userData.isEmpty = isEmpty;
                mesh.userData.slotIndex = i;
                mesh.userData.personIndex = personIndex;

                this.photoGroup.add(mesh);
            }

            this.renderedCount = realCount;
            // 记录已渲染的人员名单
            this.renderedNameList = this.names.slice(0, realCount).map(p => p.name);
        },

        createAvatarTexture(person) {
            return new Promise(resolve => {
                const canvas = document.createElement('canvas');
                canvas.width = 256;
                canvas.height = 256;
                const ctx = canvas.getContext('2d');
                const finish = () => {
                    const texture = new THREE.CanvasTexture(canvas);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                const drawRoundRect = (x, y, width, height, radius) => {
                    ctx.beginPath();
                    ctx.moveTo(x + radius, y);
                    ctx.lineTo(x + width - radius, y);
                    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                    ctx.lineTo(x + width, y + height - radius);
                    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                    ctx.lineTo(x + radius, y + height);
                    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                    ctx.lineTo(x, y + radius);
                    ctx.quadraticCurveTo(x, y, x + radius, y);
                    ctx.closePath();
                };
                const drawFallback = () => {
                    ctx.clearRect(0, 0, 256, 256);
                    ctx.fillStyle = '#F1E07C';
                    drawRoundRect(8, 8, 240, 240, 24);
                    ctx.fill();
                    ctx.fillStyle = '#cc0000';
                    // 无头像时完整显示姓名（不打码），名字过长时自动缩小字号
                    const fullName = person.name || '奖';
                    let fontSize = 80;
                    ctx.font = `bold ${fontSize}px Arial`;
                    while (ctx.measureText(fullName).width > 216 && fontSize > 24) {
                        fontSize -= 4;
                        ctx.font = `bold ${fontSize}px Arial`;
                    }
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(fullName, 128, 128);
                    finish();
                };

                if (!person.avatar) {
                    drawFallback();
                    return;
                }

                const image = new Image();
                image.crossOrigin = 'anonymous';
                image.onload = () => {
                    ctx.clearRect(0, 0, 256, 256);
                    ctx.save();
                    drawRoundRect(8, 8, 240, 240, 24);
                    ctx.clip();
                    ctx.drawImage(image, 8, 8, 240, 240);
                    // 饱和度增强，让颜色更鲜艳饱满
                    this.boostSaturation(ctx, 8, 8, 240, 240, 1.3);
                    ctx.restore();
                    ctx.strokeStyle = '#F1E07C';
                    ctx.lineWidth = 10;
                    drawRoundRect(8, 8, 240, 240, 24);
                    ctx.stroke();
                    finish();
                };
                image.onerror = drawFallback;
                image.src = person.avatar;
            });
        },

        // 创建空位占位纹理（描边空头像效果）
        createEmptyAvatarTexture() {
            const canvas = document.createElement('canvas');
            canvas.width = 256;
            canvas.height = 256;
            const ctx = canvas.getContext('2d');

            const drawRoundRect = (x, y, width, height, radius) => {
                ctx.beginPath();
                ctx.moveTo(x + radius, y);
                ctx.lineTo(x + width - radius, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                ctx.lineTo(x + width, y + height - radius);
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                ctx.lineTo(x + radius, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                ctx.lineTo(x, y + radius);
                ctx.quadraticCurveTo(x, y, x + radius, y);
                ctx.closePath();
            };

            // 透明背景
            ctx.clearRect(0, 0, 256, 256);

            // 描边圆角矩形
            ctx.strokeStyle = 'rgba(241, 224, 124, 1)';
            ctx.lineWidth = 6;
            drawRoundRect(8, 8, 240, 240, 24);
            ctx.stroke();

            // 画一个简单的人形轮廓（头+身体）
            ctx.fillStyle = 'rgba(241, 224, 124, 0.6)';
            // 头部
            ctx.beginPath();
            ctx.arc(128, 95, 40, 0, Math.PI * 2);
            ctx.fill();
            // 身体
            ctx.beginPath();
            ctx.arc(128, 200, 60, Math.PI * 1.2, Math.PI * 1.8);
            ctx.fill();

            const texture = new THREE.CanvasTexture(canvas);
            texture.needsUpdate = true;
            return texture;
        },

        // 饱和度增强：对指定区域的像素提升饱和度
        // factor: 1.0=不变, >1=更鲜艳, <1=更淡
        boostSaturation(ctx, x, y, w, h, factor) {
            const imageData = ctx.getImageData(x, y, w, h);
            const data = imageData.data;
            for (let i = 0; i < data.length; i += 4) {
                // 跳过完全透明的像素
                if (data[i + 3] === 0) continue;
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];
                // RGB转HSL，提升S通道
                const max = Math.max(r, g, b) / 255;
                const min = Math.min(r, g, b) / 255;
                const l = (max + min) / 2;
                let s = 0, hh = 0;
                if (max !== min) {
                    const d = max - min;
                    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                    const rn = r / 255, gn = g / 255, bn = b / 255;
                    if (max === rn) hh = ((gn - bn) / (max - min) + (gn < bn ? 6 : 0)) / 6;
                    else if (max === gn) hh = ((bn - rn) / (max - min) + 2) / 6;
                    else hh = ((rn - gn) / (max - min) + 4) / 6;
                }
                // 提升饱和度，不超过1
                const newS = Math.min(1, s * factor);
                // HSL转回RGB
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1/6) return p + (q - p) * 6 * t;
                    if (t < 1/2) return q;
                    if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                    return p;
                };
                let newR, newG, newB;
                if (newS === 0) {
                    newR = newG = newB = l;
                } else {
                    const q = l < 0.5 ? l * (1 + newS) : l + newS - l * newS;
                    const p = 2 * l - q;
                    newR = hue2rgb(p, q, hh + 1/3);
                    newG = hue2rgb(p, q, hh);
                    newB = hue2rgb(p, q, hh - 1/3);
                }
                data[i] = Math.round(newR * 255);
                data[i + 1] = Math.round(newG * 255);
                data[i + 2] = Math.round(newB * 255);
            }
            ctx.putImageData(imageData, x, y);
        },

        // 静默更新3D球：只添加新增的人员，不重建整个球
        async silentUpdatePhotoWall() {
            const newCount = this.names.length;
            const oldCount = this.renderedCount;

            // 没有新增人员，不需要更新
            if (newCount <= oldCount) return;

            // 找到所有空位的位置
            const emptySlots = [];
            this.photoGroup.children.forEach((mesh, index) => {
                if (mesh.userData.isEmpty) {
                    emptySlots.push(index);
                }
            });

            // 随机打乱空位顺序
            for (let i = emptySlots.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [emptySlots[i], emptySlots[j]] = [emptySlots[j], emptySlots[i]];
            }

            // 处理新增的人员
            const peopleToAdd = newCount - oldCount;
            for (let p = 0; p < peopleToAdd; p++) {
                if (emptySlots.length === 0) break; // 没有空位了

                const slotIndex = emptySlots.pop();
                const mesh = this.photoGroup.children[slotIndex];
                if (!mesh) continue;

                const person = this.names[oldCount + p];
                // 创建新的头像纹理
                const newTexture = await this.createAvatarTexture(person);

                // 释放旧的纹理，替换为新头像
                if (mesh.material) {
                    if (mesh.material.map) mesh.material.map.dispose();
                    mesh.material.map = newTexture;
                    // 空位变真实头像：关闭透明混合，启用alphaTest，避免颜色变淡
                    mesh.material.transparent = false;
                    mesh.material.alphaTest = 0.5;
                    mesh.material.needsUpdate = true;
                }

                mesh.userData.isEmpty = false;
                // 记录新加入的人
                this.renderedNameList.push(person.name);
            }

            this.renderedCount = Math.min(newCount, this.BALL_SLOT_COUNT);
        },

        // 启动自动刷新（每10秒静默拉取最新数据）
        startAutoRefresh() {
            this.stopAutoRefresh();
            this.autoRefreshTimer = setInterval(async () => {
                try {
                    const code = this.getActivityCode();
                    const count = 200;
                    const response = await request.get('/api/user/randomUsers', {
                        params: { code, count }
                    });

                    if (response.data.code === 200) {
                        const fetchedParticipants = response.data.data.map(this.normalizeParticipant);
                        // 找出球上还没有的新人
                        const existingNames = new Set(this.renderedNameList);
                        const trulyNewParticipants = fetchedParticipants.filter(
                            p => !existingNames.has(p.name)
                        );

                        if (trulyNewParticipants.length > 0 && this.renderedCount < this.BALL_SLOT_COUNT) {
                            // 只追加新人到名单末尾，不替换原有名单
                            this.participants = [...this.participants, ...trulyNewParticipants];
                            this.names = this.participants;
                            await this.silentUpdatePhotoWall();
                        }
                    }
                } catch (error) {
                    console.error('自动刷新参与人员失败:', error);
                }
            }, 10000);
        },

        // 停止自动刷新
        stopAutoRefresh() {
            if (this.autoRefreshTimer) {
                clearInterval(this.autoRefreshTimer);
                this.autoRefreshTimer = null;
            }
        },

        animate() {
            this.animationId = requestAnimationFrame(this.animate);

            this.photoGroup.rotation.y -= this.rotationSpeed;

            // 让所有名字面板始终朝向相机
            this.photoGroup.children.forEach(mesh => {
                if (mesh instanceof THREE.Mesh) {
                    mesh.lookAt(this.camera.position);
                }
            });

            this.renderer.render(this.scene, this.camera);
        },

        onWindowResize() {
            const canvas = this.$refs.photoWallCanvas;
            const container = canvas.parentElement;
            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;
            this.camera.aspect = canvas.width / canvas.height;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(canvas.width, canvas.height);
        },
    },
};
</script>

<style scoped>
.qiu-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('../assets/bgee.jpg');
    background-size: cover;
    background-position: center;
    overflow: hidden;
}

h1 {
    color: #ffd700;
    margin: 20px 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    font-size: 2.5em;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
}

.bigboxs {
    position: fixed;
    bottom: 0px;
    left: 50%;
    width: 100%;
    height: 100px;
    transform: translateX(-50%);
}

.bigboxs:hover .control-panel {
    transform: translateY(0);
}

.control-panel {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    gap: 20px;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    padding: 20px 30px;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.3);
    flex-wrap: wrap;
    justify-content: center;
    color: white;
    width: 100%;
    transition: all 0.3s ease-in-out;
    transform: translateY(100%);
}

.bgm-control {
    background-color: #F1E07C;
    color: #520002;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.bgm-control:hover {
    background-color: #fff;
    transform: scale(1.05);
}

.prize-selector {
    display: flex;
    align-items: center;
    gap: 10px;
}

.prize-selector label {
    font-weight: bold;
    color: white;
}

.prize-selector select {
    padding: 10px 15px;
    border-radius: 8px;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.9);
    cursor: pointer;
    min-width: 300px;
}

.lottery-info {
    display: flex;
    gap: 20px;
    color: white;
    font-weight: bold;
    align-items: center;
}

.draw-count-input {
    width: 90px;
    padding: 6px 8px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
}

.start-btn {
    padding: 12px 30px;
    background: none;
    color: white;
    border: 1px solid white;
    border-radius: 8px;
    font-size: 18px;
    box-sizing: border-box;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.start-btn:hover:not(:disabled) {
    transform: translateY(-2px);
}

.start-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.floating-baoming {
     position: fixed;
    top: 50%;
    transform: translateY(-50%);
    right: 20%;
    width: 17vw;
    z-index: 999;
    pointer-events: none;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
}

.toggle-baoming-btn {
    padding: 10px 20px;
    background:none;
    color: white;
    border: 1px solid white;
    border-radius: 8px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    white-space: nowrap;
}

.toggle-baoming-btn:hover {
    transform: translateY(-2px);
}

.reset-btn {
    padding: 12px 30px;
    background: linear-gradient(135deg, #f87200 0%, #ff0000 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.reset-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(78, 205, 196, 0.4);
}

.reset-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.threejs-photo-wall {
    flex: 1;
    width: 100%;
    position: relative;
}

.threejs-photo-wall canvas {
    width: 100%;
    height: 100%;
}

.result-panel {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.95);
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    max-height: 70vh;
    overflow-y: auto;
    width: 350px;
    z-index: 1000;
}

.result-panel h3 {
    margin-top: 0;
    color: #333;
    text-align: center;
    border-bottom: 2px solid #667eea;
    padding-bottom: 10px;
}

.winners-list {
    max-height: 60vh;
    overflow-y: auto;
}

.winner-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin: 5px 0;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 8px;
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.winner-name {
    font-weight: bold;
    color: #333;
}

.winner-prize {
    font-size: 12px;
    color: #666;
    text-align: right;
}

/* 中奖弹窗样式 */
.winner-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.25s ease-out;
    overflow: hidden;
}

/* 喜庆氛围 gif 图层（参考 drawanli 的 ResultPopup） */
.gif-layer {
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: 1;
    pointer-events: none;
    animation: bgPulse 4s ease-in-out infinite;
}

.gif-caise {
    opacity: 0.95;
    left: 0;
}

.gif-jingse {
    opacity: 0.75;
    mix-blend-mode: screen;
    left: 0;
}

.gif-fig {
    width: 50%;
    animation: none;
}

.gif-fig-left {
    left: 0;
}

.gif-fig-right {
    right: 0;
}

.gif-xingxing {
    width: 50vw;
    animation: none;
}

.gif-xingxing-left {
    left: 0;
}

.gif-xingxing-right {
    right: 0;
}

/* 左右扫动光束 */
.spotlight {
    position: absolute;
    top: -18vh;
    width: 18vw;
    height: 130vh;
    z-index: 2;
    opacity: 0.75;
    transform-origin: top center;
    background: linear-gradient(to bottom, rgba(255, 220, 92, 0.9), rgba(255, 93, 0, 0.12) 58%, transparent 100%);
    filter: blur(10px);
    mix-blend-mode: screen;
    pointer-events: none;
}

.spotlight-left {
    left: 17vw;
    animation: lightSweepLeft 4.6s ease-in-out infinite;
}

.spotlight-right {
    right: 17vw;
    animation: lightSweepRight 4.8s ease-in-out infinite;
}

@keyframes bgPulse {

    0%,
    100% {
        transform: scale(1);
        opacity: 0.82;
    }

    50% {
        transform: scale(1.035);
        opacity: 1;
    }
}

@keyframes lightSweepLeft {

    0%,
    100% {
        transform: rotate(-28deg);
    }

    50% {
        transform: rotate(-8deg);
    }
}

@keyframes lightSweepRight {

    0%,
    100% {
        transform: rotate(28deg);
    }

    50% {
        transform: rotate(8deg);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.winner-modal {
    position: relative;
    z-index: 5;
    width: 75vw;
    max-width: 92%;
    max-height: 88vh;
    overflow: hidden;
    border-radius: 24px;
    animation: popIn 0.3s ease-out;
    background: url("../assets/xintan.png");
    background-size: 100% 100%;
    color: #fff;
}

@keyframes popIn {
    from {
        opacity: 0;
        transform: translateY(24px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    padding: 24px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.06);
}

.modal-header h2 {
    margin: 0;
    color: #fff;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: 6px;
}

.close-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 28px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.22);
}

.modal-content {
    display: flex;
    flex-direction: row;
    height: 57vh;
}

.prize-section,
.winners-section {
    border-radius: 20px;
    height: 100%;
    box-sizing: border-box;
}

.prize-section {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding:50px 24px;
flex:1.1;
}

.prize-image {
    width: 100%;
    max-width: 420px;
    aspect-ratio: 1;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
        transform: translateY(-12%);
    overflow: hidden;
}

.prize-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.prize-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #222;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    padding: 20px;
}

.prize-name {
    /* margin-top: 4vh; */
    font-size: 24px;
    color: #1b1b1b;
    font-weight: 700;
    text-align: center;
    /* transform: translateY(4vh); */
    position: absolute;
    bottom: 11%;
}

.winners-section {
    width: 50%;
    padding:50px 24px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    flex:2;
}

.winners-section h3 {
    margin: 0 0 20px 0;
    color: #fff;
    font-size: 26px;
    text-align: center;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.winners-list-modal {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /* 人少时垂直居中；人多溢出时 safe 回退为靠顶，避免滚动裁切 */
    align-content: safe center;
    gap: 16px;
    padding-right: 6px;
}

.winner-item-modal {
    width: 140px;
    min-height: 170px;
    padding: 2px 12px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
    float:left;
    
}
.avatar-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    margin-bottom: 12px;
}

/* img 是替换元素，不支持 :after 伪元素，所以装饰环加在外层容器上 */
.avatar-wrap:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: url("@/assets/images/usercircle4.png") no-repeat center center;
    background-size: cover;
    pointer-events: none;
    animation: ringRotate 4s linear infinite;
}

@keyframes ringRotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.winner-avatar-modal,
.winner-avatar-placeholder {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.winner-avatar-modal {
    object-fit: cover;
    background: #f2f3f5;
}

.winner-avatar-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 34px;
    font-weight: 700;
  background: linear-gradient(135deg, #372612 0%, #833e00 100%);
}

.winner-name-modal {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    word-break: break-all;
}

.modal-footer {
    padding: 22px 32px 30px;
    display: flex;
    justify-content: center;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.confirm-btn {
    min-width: 160px;
    padding: 14px 48px;
    background: #fff;
    color: #1f2937;
    border: none;
    border-radius: 999px;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
}

.confirm-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 30px rgba(255, 255, 255, 0.18);
}


/* 微信浏览器遮罩层 */
.wechat-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
}

.wechat-mask-content {
    text-align: center;
    color: white;
    padding: 60px;
    background: #850000;
    border-radius: 20px;
    box-shadow: 0 0 50px rgba(255, 0, 0, 0.5);
}

.wechat-mask-content h2 {
    font-size: 3em;
    margin-bottom: 20px;
    color: #ffd700;
}

.wechat-mask-content p {
    font-size: 1.5em;
    color: #ffffff;
}
</style>
